import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { ConfiguratorResolvedDataObjectFragmentDoc } from './configurator-data-object-batch-api-call.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorResolveHdriQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfiguratorResolveHdriQuery = { __typename: 'Query', configuratorHdri?: { __typename: 'ConfiguratorDataObject', downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, originalFileName: string, mediaType?: string | null, width?: number | null, size?: any | null, imageTilesDescriptor?: { __typename: 'ConfiguratorImageTilesDescriptor', imageWidth: number, imageHeight: number, tileWidth: number, tileHeight: number, tileChannels?: number | null, tileMargin: number, tileMipLevels: number, tileMediaType: string, tileColorSpace: Types.ImageColorSpace, tileDownloadUrlPrefix: string, tileStorageFolderName: string } | null, related: Array<{ __typename: 'ConfiguratorRelatedDataObject', originalFileName: string, downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, mediaType?: string | null, width?: number | null, size?: any | null }> } | null };

export type ConfiguratorResolveHdriLegacyQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type ConfiguratorResolveHdriLegacyQuery = { __typename: 'Query', configuratorHdri?: { __typename: 'ConfiguratorDataObject', downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, originalFileName: string, mediaType?: string | null, width?: number | null, size?: any | null, imageTilesDescriptor?: { __typename: 'ConfiguratorImageTilesDescriptor', imageWidth: number, imageHeight: number, tileWidth: number, tileHeight: number, tileChannels?: number | null, tileMargin: number, tileMipLevels: number, tileMediaType: string, tileColorSpace: Types.ImageColorSpace, tileDownloadUrlPrefix: string, tileStorageFolderName: string } | null, related: Array<{ __typename: 'ConfiguratorRelatedDataObject', originalFileName: string, downloadUrl: string, height?: number | null, id: string, imageColorSpace?: Types.ImageColorSpace | null, legacyId: number, mediaType?: string | null, width?: number | null, size?: any | null }> } | null };

export const ConfiguratorResolveHdriDocument = gql`
    query configuratorResolveHdri($id: ID!) {
  configuratorHdri(id: $id) {
    ...ConfiguratorResolvedDataObject
  }
}
    ${ConfiguratorResolvedDataObjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveHdriGQL extends Apollo.Query<ConfiguratorResolveHdriQuery, ConfiguratorResolveHdriQueryVariables> {
    override document = ConfiguratorResolveHdriDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorResolveHdriLegacyDocument = gql`
    query configuratorResolveHdriLegacy($legacyId: Int!) {
  configuratorHdri(legacyId: $legacyId) {
    ...ConfiguratorResolvedDataObject
  }
}
    ${ConfiguratorResolvedDataObjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveHdriLegacyGQL extends Apollo.Query<ConfiguratorResolveHdriLegacyQuery, ConfiguratorResolveHdriLegacyQueryVariables> {
    override document = ConfiguratorResolveHdriLegacyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }